module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page1",
      "title": "1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page2",
      "title": "2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page3",
      "title": "3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp1"
  }, [_c('br'), _vm._v("\n    STILL LIFE")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("A MEMOIR "), _c('i', [_vm._v("of")]), _vm._v(" LIVING FULLY")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_c('i', [_vm._v("with")]), _vm._v(" DEPRESSION")]), _vm._v(" "), _c('p', {
    staticClass: "dingbat",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/4324_graphic_TP.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Gillian Marchenko")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivpress.com/books",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP Books Imprint",
      "src": "Images/IVPBooks.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0